module.exports = __webpack_public_path__ + "img/c22.59fb48db.png";